// frontend/src/utils/validateDominicanID.js

/**
 * Verifica si una cédula dominicana es válida según el dígito verificador.
 * Solo válida si tiene exactamente 11 dígitos numéricos.
 */
export function isValidDominicanID(nationalId) {
  const id = nationalId.replace(/\D/g, '');

  if (!/^\d{11}$/.test(id)) return false;

  const multipliers = [1, 2, 1, 2, 1, 2, 1, 2, 1, 2];
  let total = 0;

  for (let i = 0; i < 10; i++) {
    let product = parseInt(id[i]) * multipliers[i];
    if (product >= 10) product = Math.floor(product / 10) + (product % 10);
    total += product;
  }

  const checkDigit = (10 - (total % 10)) % 10;
  return checkDigit === parseInt(id[10]);
}
